module.exports = __webpack_public_path__ + "img/douyu.a5c1c611.png";